import { useEffect, useState } from 'react'
import { useAuth } from 'hooks/AuthProvider'
import { useNavigate } from 'react-router'

type AuthGuardProps = {
  children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const navigate = useNavigate()
  // const pathname = usePathname()

  const [isChecking, setIsChecking] = useState<boolean>(true)
  const { isAuthenticated, isLoading } = useAuth()

  const checkPermissions = async (): Promise<void> => {
    if (!isAuthenticated) {
      navigate('/', { replace: true })
      return
    }
    setIsChecking(false)
  }

  useEffect(() => {
    checkPermissions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, isLoading])

  if (isChecking) {
    return <h1>Cargando...</h1>
  }

  return <>{children}</>
}

export default AuthGuard
